// 子仓库 - 对账
import to from 'await-to-js';
import * as apis from "@/api/interface/reconciliation";

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    batchList: undefined, //批次 - 列表
    companyPolicyBillList: undefined, //对账 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
      // 对账 - 列表
      async getCompanyPolicyBillList(ctx, payload = {}) {
          const [err, res] = await to (apis.getCompanyPolicyBillList(payload));
          ctx.commit("update", {
              companyPolicyBillList: !err && res.data ? res.data : undefined,
          });
      },
      // 保司对账筛选
      async getCompanyPolicyBillArgOptions(_, payload = {}) {
          const [, res] = await to (apis.getCompanyPolicyBillArgOptions(payload));
          return res;
      },
      // 保单明细、保司返回差异单 - 数据导出
      async companyPolicyBillListExport(_, payload = []) {
          const [, res] = await to(apis.companyPolicyBillListExport(payload));
          return res;
      },
    // 批次 - 列表
    async getBatchList(ctx, payload = {}) {
      const [err, res] = await to (apis.getBatchList(payload));
      ctx.commit("update", {
        batchList: !err && res.data ? res.data : undefined,
      });
    },
    // 批次 - 列表
    async getBatchPageOptions(_, payload = {}) {
      const [, res] = await to (apis.getBatchPageOptions(payload));
      return res;
    },
    // 批次 - 新增、修改
    async batchAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.batchAddOrUpdate(payload));
      return res;
    },
    // 批次 - 数据导出
    async batchExport(_, payload = []) {
      const [, res] = await to(apis.batchExport(...payload));
      return res;
    },
    // 批次 - 数据上传
    async batchUpload(_, payload = []) {
      const [, res] = await to(apis.batchUpload(...payload));
      return res;
    },
  },
  modules: {},
};
